import i18n from '../i18nService';
import { preferenceGroupNamesService } from './preferenceGroupNamesService';

export const preferencesGroupsService = {
    getLocalization(localeCode, groupOrCode, withCodeReplace, i18nInstance = i18n) {
        return preferenceGroupNamesService.getLocalization(localeCode, groupOrCode, withCodeReplace, i18nInstance);
    },
    getPlaceholder(i18nInstance = i18n) {
        return preferenceGroupNamesService.getPlaceholder(i18nInstance);
    },
};
